/* ==========================================================================
   ROXX — Produktseite
   1. Variantenbeschriftungen "Menge · Grundpreis" zweizeilig darstellen
   2. Grundpreiszeile unter dem Preis bei Variantenwechsel aktualisieren
   3. Tabellen in der Beschreibung horizontal scrollbar kapseln
   Kein Framework, keine neuen Abhaengigkeiten.
   ========================================================================== */
(function () {
  'use strict';

  var SEP = '·';

  function splitLabels() {
    var labels = document.querySelectorAll('.variant__button-label');
    if (!labels.length) return;

    labels.forEach(function (label) {
      if (label.querySelector('.roxx-vlabel__main')) return;

      var text = label.textContent.trim();
      var idx = text.indexOf(SEP);
      if (idx === -1) return;

      var main = text.slice(0, idx).trim();
      var sub = text.slice(idx + 1).trim();
      if (!main || !sub) return;

      label.textContent = '';

      var mainEl = document.createElement('span');
      mainEl.className = 'roxx-vlabel__main';
      mainEl.textContent = main;

      var subEl = document.createElement('span');
      subEl.className = 'roxx-vlabel__sub';
      subEl.textContent = sub;

      label.appendChild(mainEl);
      label.appendChild(subEl);
    });
  }

  /* Nicht verfuegbare Optionen kennzeichnen ------------------------------- */

  /* Expanse markiert ausverkaufte Optionswerte nicht. Die Variantendaten
     liegen bereits als JSON in der Variantenauswahl - daraus wird ermittelt,
     welche Optionswerte in KEINER Kombination lieferbar sind. Nur diese
     werden deaktiviert; sie bleiben sichtbar (Baymard). */
  function markUnavailableOptions() {
    var picker = document.querySelector('block-variant-picker');
    if (!picker) return;

    var json = picker.querySelector('script[type="application/json"]');
    if (!json) return;

    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var available = {}; // "option1::Wert" -> true
    variants.forEach(function (v) {
      if (!v.available) return;
      ['option1', 'option2', 'option3'].forEach(function (key) {
        if (v[key]) available[key + '::' + v[key]] = true;
      });
    });

    picker.querySelectorAll('.variant-button-wrap').forEach(function (group) {
      var inputs = [].slice.call(group.querySelectorAll('input[type="radio"]'));
      if (inputs.length < 2) return;

      var flags = inputs.map(function (input) {
        var key = (input.dataset.index || 'option1') + '::' + input.value;
        return available[key] === true;
      });

      // Wenn nichts lieferbar ist, nichts deaktivieren - sonst waere die
      // Auswahl komplett blockiert.
      if (flags.every(function (f) { return !f; })) return;

      inputs.forEach(function (input, i) {
        var label = group.querySelector('label[for="' + input.id + '"]');
        if (!label) return;

        if (flags[i]) {
          input.disabled = false;
          label.classList.remove('is-unavailable');
          label.removeAttribute('title');
        } else {
          input.disabled = true;
          label.classList.add('is-unavailable');
          label.setAttribute('title', 'Derzeit nicht verfügbar');
        }
      });
    });
  }

  function unitTextForCurrentVariant() {
    var checked = document.querySelector('.variant-button-wrap input:checked');
    if (!checked) return null;
    var value = checked.value || '';
    var idx = value.indexOf(SEP);
    return idx === -1 ? null : value.slice(idx + 1).trim();
  }

  function syncUnitPrice() {
    var host = document.querySelector('[data-roxx-unit]');
    if (!host) return;

    var text = unitTextForCurrentVariant();
    if (!text) {
      host.hidden = true;
      return;
    }

    var target = host.querySelector('[data-roxx-unit-value]');
    if (target) target.textContent = text;
    host.hidden = false;
  }

  function wrapTables() {
    document.querySelectorAll('.template-product .rte table').forEach(function (table) {
      var parent = table.parentElement;
      if (parent && parent.classList.contains('roxx-table-scroll')) return;

      var wrap = document.createElement('div');
      wrap.className = 'roxx-table-scroll';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('aria-label', 'Tabelle, horizontal scrollbar');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  function refresh() {
    splitLabels();
    markUnavailableOptions();
    syncUnitPrice();
    wrapTables();
  }

  function boot() {
    refresh();

    var idInput = document.querySelector('block-buy-buttons input[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', function () {
        setTimeout(refresh, 0);
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target.closest && event.target.closest('.variant-button-wrap')) {
        setTimeout(refresh, 0);
      }
    });

    var picker = document.querySelector('block-variant-picker');
    if (picker && 'MutationObserver' in window) {
      new MutationObserver(function () {
        splitLabels();
        markUnavailableOptions();
        syncUnitPrice();
      }).observe(picker, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.collapsible-trigger')) {
        setTimeout(wrapTables, 250);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();